/* eslint-disable import/prefer-default-export */

// import store from "../../../store";

export const checkStatus = {
  created() {
    const { orderId, productId } = this.$route.query;
    if (productId && orderId) {
      this.$store.dispatch('commonForms/updateCommon', {
        orderId,
        productId,
      });
    }
  },
};
